import { Modals, Consts } from '../dependencies';

import CreateTagButton from '../components/CreateTagButton';

const { withModal } = Modals.HOC;

export default withModal(Consts.modals.CREATE_TAG)(CreateTagButton);
